import { render, staticRenderFns } from "./DraggedItem.vue?vue&type=template&id=45e0c293&lang=pug&"
import script from "./DraggedItem.vue?vue&type=script&lang=js&"
export * from "./DraggedItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggedItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e0c293')) {
      api.createRecord('45e0c293', component.options)
    } else {
      api.reload('45e0c293', component.options)
    }
    module.hot.accept("./DraggedItem.vue?vue&type=template&id=45e0c293&lang=pug&", function () {
      api.rerender('45e0c293', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/DraggedItem.vue"
export default component.exports